export const RESET = 'SPEAKER_LIST_RESET';
export const SET_ITEMS = 'SPEAKER_LIST_SET_ITEMS';
export const SET_ERROR = 'SPEAKER_LIST_SET_ERROR';
export const SET_SELECT_ITEMS = 'SPEAKER_LIST_SET_SELECT_ITEMS';
export const SET_VIEW = 'SPEAKER_LIST_SET_VIEW';
export const TOGGLE_LOADING = 'SPEAKER_LIST_TOGGLE_LOADING';



// WEBPACK FOOTER //
// ./src/store/modules/speaker/list/mutation_types.js